import { render, staticRenderFns } from "./CheckBoxQuestion.vue?vue&type=template&id=0f6508d0&scoped=true"
import script from "./CheckBoxQuestion.vue?vue&type=script&lang=js"
export * from "./CheckBoxQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6508d0",
  null
  
)

export default component.exports